module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 483
// module chunks = 0 1